var BooleanInverseValueConverter = /** @class */ (function () {
    function BooleanInverseValueConverter() {
    }
    BooleanInverseValueConverter.prototype.toView = function (value, format) {
        return !value;
    };
    BooleanInverseValueConverter.prototype.fromView = function (value, format) {
        return !value;
    };
    return BooleanInverseValueConverter;
}());
export { BooleanInverseValueConverter };
